/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import { j as u } from "../../chunks/jsx-runtime.BwWtxLpl.js";
import t from "react";
const e = t.createContext({
  formData: {},
  registerFormData: () => null
}), x = () => t.useContext(e), l = ({ children: r }) => {
  const [o, a] = t.useState({}), s = t.useCallback(
    (m, n) => {
      a((c) => ({ ...c, [m]: n }));
    },
    []
  );
  return /* @__PURE__ */ u.jsx(e.Provider, { value: { formData: o, registerFormData: s }, children: r });
};
export {
  l as default,
  x as useFormeckStepper
};
